import grey from '@mui/material/colors/grey'
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  typography: {
    fontWeightMedium: 600,
    button: {
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: '#038755',
      light: '#05D686',
      contrastText: '#fff',
    },
    secondary: {
      main: '#333',
    },
    background: {
      default: '#fff',
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiTextField: {
      // added when migraring MUI 4 -> MUI 5
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          padding: 12,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        marginDense: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: '100%',
        },
        body: {
          height: '100%',
          fontSize: '0.875rem', // MUI 4 default
        },
        '#root': {
          height: '100%',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: grey[50],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          minWidth: 96,
          '.MuiButtonBase-root + &': {
            marginLeft: 16,
          },
        },
      },
    },
  },
})

export default theme
